import {Dispatch} from 'redux';
import {
  SPORTEVENTS_BY_SPORT_MONTH_GET_INVALIDATE,
  SPORTEVENTS_BY_SPORT_MONTH_GET_REQUEST,
  SPORTEVENTS_BY_SPORT_MONTH_GET_RESPONSE,
} from '../../actionTypes';
import {
  SportEventsBySportTypeAndMonthGetInvalidateAction,
  SportEventsBySportTypeAndMonthGetRequestAction,
  SportEventsBySportTypeAndMonthGetResponseAction,
} from '../types';
import {sportEventsBySportTypeAndMonth} from '../../../API/sportEvents';
import {MatchSimple, Sport} from '../../../utils/types';
import standardizeError from '../../../utils/standardizeError';
import {beMatchSimpleToMatchSimple, sportToBeSport} from '../../../API/utils';
import {BESport} from '../../../API/types';

/**
 *  Action creator for the get request of the sport events by sport and month
 * @param sportType
 * @param month in format 'yyyy-MM'
 */
const getSportEventsBySportTypeGetRequest = (
  sportType: BESport,
  month: string
): SportEventsBySportTypeAndMonthGetRequestAction => ({
  type: SPORTEVENTS_BY_SPORT_MONTH_GET_REQUEST,
  payload: {
    sportType,
    month,
  },
});

/**
 * Action creator for the request response of the sport events by sport and month
 * @param matches
 */
const getSportEventsBySportTypeGetResponse = (
  matches: MatchSimple[]
): SportEventsBySportTypeAndMonthGetResponseAction => ({
  type: SPORTEVENTS_BY_SPORT_MONTH_GET_RESPONSE,
  payload: {matches},
});

/**
 * Action creator for the request invalidate of the sport events by sport and month
 * @param error
 */
const getSportEventsBySportTypeGetInvalidate = (
  error: Error
): SportEventsBySportTypeAndMonthGetInvalidateAction => ({
  type: SPORTEVENTS_BY_SPORT_MONTH_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * Getting matches by sport and month
 * @param sport
 * @param month in format 'yyyy-MM'
 */
const getSportEventsBySportTypeAndMonth = (sportType: Sport, month: string) => (
  dispatch: Dispatch
): Promise<any> => {
  const beSport = sportToBeSport(sportType);
  dispatch(getSportEventsBySportTypeGetRequest(beSport, month));

  return (
    sportEventsBySportTypeAndMonth(beSport, month)
      // TODO: remove filters
      .then(data =>
        data.filter(match =>
          [BESport.SOCCER, BESport.BASKETBALL, BESport.TENNIS, BESport.HANDBALL, BESport.VOLLEYBALL].includes(match.sportType)
        )
      )
      .then(data => data.map(beMatchSimpleToMatchSimple))
      .then((matches: MatchSimple[]) => dispatch(getSportEventsBySportTypeGetResponse(matches)))
      .catch((error: Error) => dispatch(getSportEventsBySportTypeGetInvalidate(error)))
  );
};

export default getSportEventsBySportTypeAndMonth;
